/**
 * SGKC031A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ReimporttargetLstInfo {

    /**
     * 発生日
     */
    occureDate?: string;
    /**
     * 供給地点特定番号
     */
    suppntSpno?: string;    
    /**
     * ご使用者名
     */
    userMei?: string;
    /**
     * 対象年月
     */
    targetYm?: string;
    /**
     * ご使用開始日
     */
    usageStartdate?: string;
    /**
     * ご使用終了日
     */
    usageEnddt?: string;
    /**
     * 使用日数
     */
    empday?: string;
    /**
     * 使用量
     */
    empamt?: number;
    /**
     * 再取込処理ステータスコード
     */
    reimportTrnStatuscode?: string;
    /**
     * 備考
     */
    biko?: string;
    /**
     * 確定使用量再取込管理通番号
     */
    fixempCspManageno?: string;        
    /**
     * 再取込グループ番号
     */
    reimportGroupNo?: string;  
}

